module.exports = __webpack_public_path__ + "img/onboarding-checklist.d31b169d.png";